var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_81_3058",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_81_3058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 24C3.0875 24 2.73442 23.851 2.44075 23.553C2.14692 23.2548 2 22.8965 2 22.478C2 22.0593 2.14933 21.7042 2.448 21.4125C2.74667 21.1208 3.10567 20.975 3.525 20.975H20.5C20.9125 20.975 21.2657 21.1223 21.5595 21.417C21.8532 21.7115 22 22.0657 22 22.4795C22 22.8932 21.8507 23.25 21.552 23.55C21.2533 23.85 20.8943 24 20.475 24H3.5ZM5.5 16.475H6.6L16.375 6.7L15.275 5.6L5.5 15.375V16.475ZM4 17.2235V15.1003C4 15.0001 4.01667 14.9042 4.05 14.8125C4.08333 14.7208 4.14167 14.6333 4.225 14.55L16.35 2.425C16.5 2.275 16.6667 2.16667 16.85 2.1C17.0333 2.03333 17.2167 2 17.4 2C17.5833 2 17.7708 2.03333 17.9625 2.1C18.1542 2.16667 18.3167 2.275 18.45 2.425L19.55 3.525C19.7 3.65833 19.8125 3.82083 19.8875 4.0125C19.9625 4.20417 20 4.39458 20 4.58375C20 4.76125 19.9642 4.94133 19.8925 5.124C19.8207 5.30683 19.7065 5.47383 19.55 5.625L7.425 17.75C7.34167 17.8333 7.2565 17.8917 7.1695 17.925C7.08267 17.9583 6.99283 17.975 6.9 17.975H4.75825C4.54342 17.975 4.36333 17.903 4.218 17.759C4.07267 17.6148 4 17.4363 4 17.2235Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.c4bb6e7c72d69a3980f66be44e5725ca.svg";
export { ForwardRef as ReactComponent };